import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';
import * as odActions from './OverallDevelopment/actions';

export const FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST =
  'FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST';
export const FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS =
  'FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS';
export const FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE =
  'FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE';

export const FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST =
  'FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST';
export const FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS =
  'FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS';
export const FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE =
  'FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE';

export const GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST =
  'GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST';
export const GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS =
  'GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS';
export const GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE =
  'GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE';

export const FETCH_IDP_LEARNING_RESULT_REQUEST =
  'FETCH_IDP_LEARNING_RESULT_REQUEST';
export const FETCH_IDP_LEARNING_RESULT_SUCCESS =
  'FETCH_IDP_LEARNING_RESULT_SUCCESS';
export const FETCH_IDP_LEARNING_RESULT_FAILURE =
  'FETCH_IDP_LEARNING_RESULT_FAILURE';

export const FETCH_IDP_CHECK_REQUEST = 'FETCH_IDP_CHECK_REQUEST';
export const FETCH_IDP_CHECK_SUCCESS = 'FETCH_IDP_CHECK_SUCCESS';
export const FETCH_IDP_CHECK_FAILURE = 'FETCH_IDP_CHECK_FAILURE';

export const FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST =
  'FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST';
export const FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS =
  'FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS';
export const FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE =
  'FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE';

export const SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST =
  'SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST';
export const SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS =
  'SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS';
export const SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE =
  'SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE';

export const SUBMIT_IDP_PERIOD_REQUEST = 'SUBMIT_IDP_PERIOD_REQUEST';
export const SUBMIT_IDP_PERIOD_SUCCESS = 'SUBMIT_IDP_PERIOD_SUCCESS';
export const SUBMIT_IDP_PERIOD_FAILURE = 'SUBMIT_IDP_PERIOD_FAILURE';

export const SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST = 'SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST';
export const SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS = 'SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS';
export const SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE = 'SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE';

export const FETCH_IDP_APPROVAL_LIST_REQUEST = 'FETCH_IDP_APPROVAL_LIST_REQUEST';
export const FETCH_IDP_APPROVAL_LIST_SUCCESS = 'FETCH_IDP_APPROVAL_LIST_SUCCESS';
export const FETCH_IDP_APPROVAL_LIST_FAILURE = 'FETCH_IDP_APPROVAL_LIST_FAILURE';

export const APPROVE_STUDENT_IDP_REPORT_REQUEST = 'APPROVE_STUDENT_IDP_REPORT_REQUEST';
export const APPROVE_STUDENT_IDP_REPORT_SUCCESS = 'APPROVE_STUDENT_IDP_REPORT_SUCCESS';
export const APPROVE_STUDENT_IDP_REPORT_FAILURE = 'APPROVE_STUDENT_IDP_REPORT_FAILURE';

export const FETCH_IDP_PARTICIPATION_REQUEST = 'FETCH_IDP_PARTICIPATION_REQUEST';
export const FETCH_IDP_PARTICIPATION_SUCCESS = 'FETCH_IDP_PARTICIPATION_SUCCESS';
export const FETCH_IDP_PARTICIPATION_FAILURE = 'FETCH_IDP_PARTICIPATION_FAILURE';

export const REJECT_STUDENT_IDP_REPORT_REQUEST = 'REJECT_STUDENT_IDP_REPORT_REQUEST';
export const REJECT_STUDENT_IDP_REPORT_SUCCESS = 'REJECT_STUDENT_IDP_REPORT_SUCCESS';
export const REJECT_STUDENT_IDP_REPORT_FAILURE = 'REJECT_STUDENT_IDP_REPORT_FAILURE';

const buildIdpListUrl = (groupIdpId) => buildUrl(`/group-compulsory-idps/${groupIdpId}`);

export function fetchIndividualDevelopmentPlanListIfNeeded(groupIdpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpListUrl(groupIdpId) })) {
      return false;
    }

    return dispatch(fetchIndividualDevelopmentPlanList(groupIdpId));
  };
}

export function fetchIndividualDevelopmentPlanList(groupIdpId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildIdpListUrl(groupIdpId);

    return dispatch(fetchIndividualDevelopmentPlanListRequest()).payload
      .then((response) => dispatch(fetchIndividualDevelopmentPlanListSuccess(response)))
      .catch((error) => dispatch(fetchIndividualDevelopmentPlanListFailure(error)));

    function fetchIndividualDevelopmentPlanListRequest() {
      return ApiCall.createAction({
        type: FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchIndividualDevelopmentPlanListSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        groupIdpId: parseInt(groupIdpId, 10),
        method,
        url,
      });
    }

    function fetchIndividualDevelopmentPlanListFailure(error) {
      return ApiCall.createAction({
        type: FETCH_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const buildGroupIdpListUrl = (groupId) => buildUrl(`/groups/${groupId}/group-compulsory-idps`);

export function fetchGroupIndividualDevelopmentPlanListIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildGroupIdpListUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchGroupIndividualDevelopmentPlanList(groupId));
  };
}

export function fetchGroupIndividualDevelopmentPlanList(groupId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildGroupIdpListUrl(groupId);

    return dispatch(fetchGroupIndividualDevelopmentPlanListRequest()).payload
      .then((response) => dispatch(fetchGroupIndividualDevelopmentPlanListSuccess(response)))
      .catch((error) => dispatch(fetchGroupIndividualDevelopmentPlanListFailure(error)));

    function fetchGroupIndividualDevelopmentPlanListRequest() {
      return ApiCall.createAction({
        type: FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchGroupIndividualDevelopmentPlanListSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        groupId,
        method,
        url,
      });
    }

    function fetchGroupIndividualDevelopmentPlanListFailure(error) {
      return ApiCall.createAction({
        type: FETCH_GROUP_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function generateIndividualDevelopmentList(groupIdpId) {
  return (dispatch) => {
    const method = 'POST';
    const url = buildUrl(`/group-compulsory-idps/${groupIdpId}`);

    return dispatch(generateIndividualDevelopmentListRequest()).payload
      .then((response) => dispatch(generateIndividualDevelopmentListSuccess(response)))
      .catch((error) => dispatch(generateIndividualDevelopmentListFailure(error)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)));

    function generateIndividualDevelopmentListRequest() {
      return ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_REQUEST,
        payload: fetch(url, { method }),
        method,
        url,
      });
    }

    function generateIndividualDevelopmentListSuccess(response) {
      return ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function generateIndividualDevelopmentListFailure(error) {
      return ApiCall.createAction({
        type: GENERATE_INDIVIDUAL_DEVELOPMENT_PLAN_LIST_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const buildIdpCheckUrl = (idpId) => buildUrl(`/student-idps/${idpId}/check`);

export function fetchIdpCheck(idpId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildIdpCheckUrl(idpId);

    return dispatch(fetchIdpCheckRequest()).payload
      .then((response) => dispatch(fetchIdpCheckSuccess(response)))
      .catch((error) => dispatch(fetchIdpCheckFailure(error)));

    function fetchIdpCheckRequest() {
      return ApiCall.createAction({
        type: FETCH_IDP_CHECK_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchIdpCheckSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_IDP_CHECK_SUCCESS,
        payload: response,
        idpId,
        method,
        url,
      });
    }

    function fetchIdpCheckFailure(error) {
      return ApiCall.createAction({
        type: FETCH_IDP_CHECK_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const buildIdpLearningResultUrl = (idpId) => buildUrl(`/student-idps/${idpId}/learning-result`);

export function fetchIdpLearningResultIfNeeded(idpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpLearningResultUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchIdpLearningResult(idpId));
  };
}

export function fetchIdpLearningResult(idpId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildIdpLearningResultUrl(idpId);

    return dispatch(fetchIdpLearningResultRequest()).payload
      .then((response) => dispatch(fetchIdpLearningResultSuccess(response)))
      .catch((error) => dispatch(fetchIdpLearningResultFailure(error)));

    function fetchIdpLearningResultRequest() {
      return ApiCall.createAction({
        type: FETCH_IDP_LEARNING_RESULT_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchIdpLearningResultSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_IDP_LEARNING_RESULT_SUCCESS,
        payload: response,
        idpId,
        method,
        url,
      });
    }

    function fetchIdpLearningResultFailure(error) {
      return ApiCall.createAction({
        type: FETCH_IDP_LEARNING_RESULT_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const buildIdpFeedbackSuggestionsUrl = (idpId) => buildUrl(`/student-idps/${idpId}/feedback-suggestions`);

export function fetchIdpFeedbackSuggestionsIfNeeded(idpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpFeedbackSuggestionsUrl(idpId) })) {
      return false;
    }

    return dispatch(fetchIdpFeedbackSuggestions(idpId));
  };
}

export function fetchIdpFeedbackSuggestions(idpId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildIdpFeedbackSuggestionsUrl(idpId);

    return dispatch(fetchIdpFeedbackSuggestionsRequest()).payload
      .then((response) => dispatch(fetchIdpFeedbackSuggestionsSuccess(response)))
      .catch((error) => dispatch(fetchIdpFeedbackSuggestionsFailure(error)));

    function fetchIdpFeedbackSuggestionsRequest() {
      return ApiCall.createAction({
        type: FETCH_IDP_FEEDBACK_SUGGESTIONS_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchIdpFeedbackSuggestionsSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_IDP_FEEDBACK_SUGGESTIONS_SUCCESS,
        payload: response,
        idpId,
        method,
        url,
      });
    }

    function fetchIdpFeedbackSuggestionsFailure(error) {
      return ApiCall.createAction({
        type: FETCH_IDP_FEEDBACK_SUGGESTIONS_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function submitIdpFeedbackSuggestions(idpId, suggestions, groupIdpId) {
  return (dispatch) => {
    const method = 'PUT';
    const url = buildUrl(`/student-idps/${idpId}/feedback-suggestions`);
    suggestions.skillSuggestions && suggestions.skillSuggestions.forEach((skillSuggestion) => {
      // eslint-disable-next-line no-param-reassign
      skillSuggestion.selectedRecommendationList =
        skillSuggestion.selectedRecommendationList.map((id) => parseInt(id, 10));
    });
    return dispatch(submitIdpFeedbackSuggestionsRequest()).payload
      .then((response) => dispatch(submitIdpFeedbackSuggestionsSuccess(response)))
      .catch((error) => dispatch(submitIdpFeedbackSuggestionsFailure(error)))
      .then(() => dispatch(fetchIdpFeedbackSuggestions(idpId)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)));

    function submitIdpFeedbackSuggestionsRequest() {
      const body = JSON.stringify(suggestions);
      return ApiCall.createAction({
        type: SUBMIT_IDP_FEEDBACK_SUGGESTIONS_REQUEST,
        payload: fetch(url, { method, body }),
        method,
        url,
      });
    }

    function submitIdpFeedbackSuggestionsSuccess(response) {
      return ApiCall.createAction({
        type: SUBMIT_IDP_FEEDBACK_SUGGESTIONS_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function submitIdpFeedbackSuggestionsFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_IDP_FEEDBACK_SUGGESTIONS_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function submitIdpPeriod(idpId, period, groupIdpId) {
  return (dispatch) => {
    const method = 'PUT';
    const url = buildUrl(`/student-idps/${idpId}`);

    return dispatch(submitIdpPeriodRequest()).payload
      .then((response) => dispatch(submitIdpPeriodSuccess(response)))
      .catch((error) => dispatch(submitIdpPeriodFailure(error)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)))
      .then(() => dispatch(fetchIdpLearningResult(idpId)))
      .then(() => dispatch(fetchIdpFeedbackSuggestions(idpId)))
      .then(() => dispatch(odActions.fetchOverallDevelopmentTemplate(idpId)))
      .then(() => dispatch(odActions.fetchOverallDevelopmentResult(idpId)));

    function submitIdpPeriodRequest() {
      const body = JSON.stringify(period);
      return ApiCall.createAction({
        type: SUBMIT_IDP_PERIOD_REQUEST,
        payload: fetch(url, { method, body }),
        method,
        url,
      });
    }

    function submitIdpPeriodSuccess(response) {
      return ApiCall.createAction({
        type: SUBMIT_IDP_PERIOD_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function submitIdpPeriodFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_IDP_PERIOD_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function submitIndividualDevelopmentPlan(idpId, groupIdpId) {
  return (dispatch) => {
    const method = 'PUT';
    const url = buildUrl(`/student-idps/${idpId}/submit`);

    return dispatch(submitIndividualDevelopmentPlanRequest()).payload
      .then((response) => dispatch(submitIndividualDevelopmentPlanSuccess(response)))
      .catch((error) => dispatch(submitIndividualDevelopmentPlanFailure(error)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)));

    function submitIndividualDevelopmentPlanRequest() {
      return ApiCall.createAction({
        type: SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_REQUEST,
        payload: fetch(url, { method }),
        method,
        url,
      });
    }

    function submitIndividualDevelopmentPlanSuccess(response) {
      return ApiCall.createAction({
        type: SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function submitIndividualDevelopmentPlanFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_INDIVIDUAL_DEVELOPMENT_PLAN_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const buildIdpApprovalListUrl =
  (groupIdpId) => buildUrl(`/group-compulsory-idps/${groupIdpId}/dos-approval`);

export function fetchIdpApprovalListIfNeeded(groupIdpId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpApprovalListUrl(groupIdpId) })) {
      return false;
    }

    return dispatch(fetchIdpApprovalList(groupIdpId));
  };
}

export function fetchIdpApprovalList(groupIdpId) {
  return (dispatch) => {
    const method = 'GET';
    const url = buildIdpApprovalListUrl(groupIdpId);

    return dispatch(fetchIdpApprovalListRequest()).payload
      .then((response) => {
        response.forEach((idpApproval) =>
            dispatch(fetchIdpFeedbackSuggestions(idpApproval.studentIDPId.toString())));
        return dispatch(fetchIdpApprovalListSuccess(response));
      })
      .catch((error) => dispatch(fetchIdpApprovalListFailure(error)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)));

    function fetchIdpApprovalListRequest() {
      return ApiCall.createAction({
        type: FETCH_IDP_APPROVAL_LIST_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchIdpApprovalListSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_IDP_APPROVAL_LIST_SUCCESS,
        payload: response,
        groupIdpId,
        method,
        url,
      });
    }

    function fetchIdpApprovalListFailure(error) {
      return ApiCall.createAction({
        type: FETCH_IDP_APPROVAL_LIST_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function approveStudentIdpReport(idpId, groupIdpId) {
  return (dispatch) => {
    const method = 'PUT';
    const url = buildUrl(`/student-idps/${idpId}/dos-approve`);

    return dispatch(approveStudentIdpReportRequest()).payload
      .then((response) => dispatch(approveStudentIdpReportSuccess(response)))
      .catch((error) => dispatch(approveStudentIdpReportFailure(error)))
      .then(() => dispatch(fetchIdpApprovalList(groupIdpId)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)));

    function approveStudentIdpReportRequest() {
      return ApiCall.createAction({
        type: APPROVE_STUDENT_IDP_REPORT_REQUEST,
        payload: fetch(url, { method }),
        method,
        url,
      });
    }

    function approveStudentIdpReportSuccess(response) {
      return ApiCall.createAction({
        type: APPROVE_STUDENT_IDP_REPORT_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function approveStudentIdpReportFailure(error) {
      return ApiCall.createAction({
        type: APPROVE_STUDENT_IDP_REPORT_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

export function rejectStudentIdpReport(idpId, groupIdpId, rejectedComment) {
  return (dispatch) => {
    const method = 'PUT';
    const url = buildUrl(`/student-idps/${idpId}/dos-reject?rejectedComment=${rejectedComment}`);

    return dispatch(rejectStudentIdpReportRequest()).payload
      .then((response) => dispatch(rejectStudentIdpReportSuccess(response)))
      .catch((error) => dispatch(rejectStudentIdpReportFailure(error)))
      .then(() => dispatch(fetchIdpApprovalList(groupIdpId)))
      .then(() => dispatch(fetchIndividualDevelopmentPlanList(groupIdpId)));

    function rejectStudentIdpReportRequest() {
      return ApiCall.createAction({
        type: REJECT_STUDENT_IDP_REPORT_REQUEST,
        payload: fetch(url, { method }),
        method,
        url,
      });
    }

    function rejectStudentIdpReportSuccess(response) {
      return ApiCall.createAction({
        type: REJECT_STUDENT_IDP_REPORT_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function rejectStudentIdpReportFailure(error) {
      return ApiCall.createAction({
        type: REJECT_STUDENT_IDP_REPORT_FAILURE,
        method,
        url,
        error,
      });
    }
  };
}

const buildIdpParticipationUrl = buildUrl('/student-idps/participation');

export function fetchIdpParticipationIfNeeded() {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildIdpParticipationUrl })) {
      return false;
    }

    return dispatch(fetchIdpParticipation());
  };
}

export function fetchIdpParticipation() {
  return (dispatch) => {
    const method = 'GET';
    const url = buildIdpParticipationUrl;
    return dispatch(fetchIdpParticipationRequest()).payload
      .then((response) => dispatch(fetchIdpParticipationSuccess(response)))
      .catch((error) => dispatch(fetchIdpParticipationFailure(error)));

    function fetchIdpParticipationRequest() {
      return ApiCall.createAction({
        type: FETCH_IDP_PARTICIPATION_REQUEST,
        payload: fetch(url),
        method,
        url,
      });
    }

    function fetchIdpParticipationSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_IDP_PARTICIPATION_SUCCESS,
        payload: response,
        method,
        url,
      });
    }

    function fetchIdpParticipationFailure(error) {
      return ApiCall.createAction({
        type: FETCH_IDP_PARTICIPATION_FAILURE,
        error,
        method,
        url,
      });
    }
  };
}




// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/actions.js